var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.063 33.004h26.095V67.75H39.062V33.004z",
    fill: "#2D77FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.456 32.984 53.76 37.81l-1.652 1.191-1.652-1.19-6.691-4.827h16.692z",
    fill: "#F9B29C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.833 27.588v5.408l-3.72 1.776-3.732-1.776v-5.408h7.452z",
    fill: "#F9B29C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.833 27.588v2.846a7.16 7.16 0 0 1-3.524.921 7.161 7.161 0 0 1-3.928-1.164v-2.603h7.452z",
    fill: "#ED8768"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.523 35.15 65.16 50.23V33l5.02-4.484 1.07-12.703 6.649-.238 1.405 14.021a8.077 8.077 0 0 1-1.781 5.555z",
    fill: "#F9B29C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m66.644 48.421-1.484 1.812v-12.91l1.484 11.098z",
    fill: "#125AC4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m78.582 11.539-.66 4.272h-6.67l-1.691-2.99a1.04 1.04 0 0 1 1.805-1.032l.528.913.087-1.545a3.309 3.309 0 1 1 6.602.382zM26.7 35.15 39.064 50.23V33l-5.019-4.484-1.071-12.703-6.648-.238-1.405 14.021a8.077 8.077 0 0 0 1.78 5.555z",
    fill: "#F9B29C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m37.578 48.421 1.484 1.812v-12.91L37.578 48.42z",
    fill: "#125AC4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m25.64 11.539.66 4.272h6.671l1.691-2.99a1.04 1.04 0 0 0-1.805-1.032l-.529.913-.086-1.545a3.309 3.309 0 1 0-6.602.382z",
    fill: "#F9B29C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m51.066 94.605 1.102-20.097 1.022 20.097h11.946l-.091-26.855H39.186l-.096 26.855h11.976z",
    fill: "#29275C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M45.193 23.528c.971 0 1.758-.918 1.758-2.051s-.787-2.051-1.758-2.051c-.97 0-1.758.918-1.758 2.051s.787 2.051 1.758 2.051z",
    fill: "#F9B29C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M44.588 22.143c-.211-.187-.327-.423-.327-.666 0-.243.116-.48.326-.666a.148.148 0 0 0-.195-.221c-.276.243-.427.558-.427.887 0 .33.151.644.426.888.146.128.344-.091.197-.222z",
    fill: "#ED8768"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.145 23.528c.97 0 1.757-.918 1.757-2.051s-.787-2.051-1.758-2.051c-.97 0-1.757.918-1.757 2.051s.787 2.051 1.758 2.051z",
    fill: "#F9B29C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.75 22.143c.212-.187.328-.423.328-.666 0-.243-.116-.48-.327-.666a.148.148 0 0 1 .196-.221c.276.243.427.558.427.887 0 .33-.151.644-.427.888-.147.13-.342-.092-.196-.222z",
    fill: "#ED8768"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44.957 19.24v3.777a7.264 7.264 0 0 0 14.527 0V19.24a7.26 7.26 0 0 0-7.264-7.263 7.259 7.259 0 0 0-7.263 7.263z",
    fill: "#F9B29C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M54.434 20.99c0 .505.276.91.62.91.345 0 .628-.405.628-.91 0-.504-.283-.916-.627-.916-.345 0-.621.412-.621.916zM48.762 20.99c0 .505.276.91.62.91.345 0 .628-.405.628-.91 0-.504-.283-.916-.627-.916-.345 0-.621.412-.621.916z",
    fill: "#15144F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M54.757 24.91c.001.037.01.072.01.11a2.546 2.546 0 1 1-5.091 0c0-.038.01-.073.01-.11h5.07z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m44.85 20.553.106.087s.877.1.877 0 .23-1.674.23-1.674 1.568-2.189.448-4.198c.2.106 4.89 2.581 11.016.168 0 0 .852.703.585 2.619-.137.939.286 2.301.69 3.725h.684l.554-1.573s3.359-2.974.336-5.493c.043-.124.08-.242.105-.36.025-.087.044-.168.056-.25.013-.043.019-.086.025-.13.255-1.53 1.636-3.027.473-3.916 0 0-.007-.007-.013-.007-3.7-2.824-15.251-3.61-16.172 2.25 0 0-2.114.212-2.544 2.116-.441 1.903 2.544 6.636 2.544 6.636z",
    fill: "#15144F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.323 57.322a5.414 5.414 0 0 0-5.357 4.635l-3.921 26.97 7.596.292 9.036-25.37-7.354-6.527z",
    fill: "#F9B29C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.322 57.322h24.232v34.746H57.322V57.322z",
    fill: "#03C88B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M73.163 51.908v5.408l-3.72 1.777-3.732-1.777v-5.408h7.452z",
    fill: "#F9B29C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.163 51.908v2.847a7.16 7.16 0 0 1-3.524.92 7.163 7.163 0 0 1-3.928-1.164v-2.603h7.452z",
    fill: "#ED8768"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.696 47.97c.975 0 1.766-.923 1.766-2.061 0-1.139-.79-2.061-1.766-2.061s-1.766.922-1.766 2.06c0 1.139.79 2.062 1.766 2.062z",
    fill: "#F9B29C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.304 46.577c.212-.188.329-.426.329-.67 0-.244-.117-.481-.328-.668a.149.149 0 0 1 .196-.223c.277.244.429.56.429.892 0 .33-.152.646-.429.892-.148.13-.344-.093-.197-.223z",
    fill: "#ED8768"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M62.68 47.97c.976 0 1.766-.923 1.766-2.061 0-1.139-.79-2.061-1.766-2.061-.975 0-1.766.922-1.766 2.06 0 1.139.79 2.062 1.766 2.062z",
    fill: "#F9B29C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M62.084 46.787a.15.15 0 0 0-.013-.21c-.212-.188-.328-.426-.328-.67 0-.244.116-.481.328-.668a.149.149 0 0 0-.197-.223c-.277.244-.429.56-.429.892 0 .33.152.646.429.892a.15.15 0 0 0 .21-.013z",
    fill: "#ED8768"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.934 43.661v3.795a7.299 7.299 0 0 1-14.596 0V43.66a7.294 7.294 0 0 1 7.298-7.298 7.27 7.27 0 0 1 5.161 2.136 7.27 7.27 0 0 1 2.137 5.162z",
    fill: "#F9B29C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M67.414 45.417c0 .506-.278.914-.624.914s-.63-.408-.63-.914c0-.507.284-.92.63-.92.346 0 .624.413.624.92zM73.11 45.417c0 .506-.278.914-.624.914s-.63-.408-.63-.914c0-.507.284-.92.63-.92.346 0 .624.413.624.92z",
    fill: "#15144F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.09 49.355c-.002.038-.012.073-.012.11a2.558 2.558 0 1 0 5.116 0c0-.037-.01-.072-.011-.11h-5.094z",
    fill: "#fff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m77.04 44.977-.102.089s-.886.1-.886 0c0-.102-.227-1.683-.227-1.683s-1.582-2.201-.443-4.225c0 0-4.793 2.654-11.08.175 0 0-.856.707-.582 2.631.134.944-.293 2.317-.698 3.747h-.683l-.557-1.582s-2.694-4.959.342-7.489c0 0-1.076-4.048 3.453-5.49l.747 2.39s1.784-2.808 5.338-2.96c3.568-.164 2.796 3.074 2.796 3.074s2.265-1.062 3.138.127c.86 1.19-.557 2.404-.557 2.404s1.139.822 1.569 2.732c.443 1.91-1.569 6.06-1.569 6.06z",
    fill: "#15144F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.92 59.47 81.556 74.552V57.32l5.019-4.484 1.071-12.704 6.648-.237 1.405 14.02a8.077 8.077 0 0 1-1.78 5.555z",
    fill: "#F9B29C"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m94.979 35.859-.66 4.273h-6.671l-1.691-2.991a1.04 1.04 0 0 1 1.805-1.032l.529.914.086-1.546a3.309 3.309 0 1 1 6.602.382z",
    fill: "#F9B29C"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m81.45 94.606-.008-2.536H57.447l-.01 2.536H81.45z",
    fill: "#393982"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M55.69 92.692a.954.954 0 0 1-.447.103.984.984 0 0 1-.82-.429l-.54-.81-.215 3.047h-7.045l1.426-5.675 7.594.298.55 2.376a.988.988 0 0 1-.503 1.09z",
    fill: "#F9B29C"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13.905 67c0 1.486 20.112 1.486 20.112 0-1.927-5.966 5.188-20.309-3.414-25.949-7.284-4.776-10.938.992-10.938.992s-1.901-1.146-4.96 1.512c-4.388 3.81-.403 11.866-.403 11.866.667 2.594-.051 8.935-.396 11.58z",
    fill: "#15144F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M14.873 68.672h18.979v25.93H14.873v-25.93z",
    fill: "#FF8E2E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "m28.368 61.666.058 7.009h-8.118l-.058-7.009h8.118z",
    fill: "#F9B29C"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M28.425 61.666v4.22c-2.875.136-5.567-.552-8.118-1.927v-2.293h8.118z",
    fill: "#ED8768"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M30.31 68.676a6.216 6.216 0 0 1-5.976 4.508 6.205 6.205 0 0 1-5.967-4.508H30.31zM32.6 57.012c1.151 0 2.084-1.088 2.084-2.43s-.932-2.43-2.083-2.43c-1.15 0-2.083 1.088-2.083 2.43s.932 2.43 2.083 2.43z",
    fill: "#F9B29C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M33.319 55.372c.25-.22.388-.5.388-.788 0-.289-.138-.569-.387-.79a.175.175 0 0 1 .231-.262c.327.288.506.661.506 1.052 0 .39-.18.762-.505 1.051-.175.154-.406-.11-.233-.263z",
    fill: "#ED8768"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M16.076 57.012c1.15 0 2.083-1.088 2.083-2.43s-.933-2.43-2.083-2.43c-1.151 0-2.084 1.088-2.084 2.43s.933 2.43 2.084 2.43z",
    fill: "#F9B29C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M15.36 55.372c-.25-.22-.388-.5-.388-.788 0-.289.137-.569.386-.79a.175.175 0 0 0-.23-.262c-.328.288-.507.661-.507 1.052 0 .39.18.762.505 1.051.175.153.407-.108.233-.263z",
    fill: "#ED8768"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M32.94 49.748v6.665a8.605 8.605 0 0 1-8.602 8.602 8.598 8.598 0 0 1-8.604-8.602v-6.665a8.6 8.6 0 0 1 8.604-8.603 8.605 8.605 0 0 1 8.603 8.602z",
    fill: "#F9B29C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M21.717 54.005c0 .598-.328 1.078-.736 1.078s-.743-.48-.743-1.078c0-.597.335-1.085.743-1.085s.736.488.736 1.085zM28.434 54.005c0 .598-.328 1.078-.736 1.078s-.743-.48-.743-1.078c0-.597.335-1.085.743-1.085s.736.488.736 1.085z",
    fill: "#15144F"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M21.335 58.648c-.002.044-.013.085-.013.13a3.016 3.016 0 1 0 6.032 0c0-.045-.011-.086-.013-.13h-6.006z",
    fill: "#fff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m33.345 49.544-.381 2.67c0 2.812-1.333 4.504-1.333 4.504s-.37-2.655-1.938-5.4c-1.568-2.744-6.721-4.491-9.017-5.31-.527-.19-.907-.447-1.177-.727-.223 2.879-3.606 10.686-3.74 10.44l-.099-5.968c0-4.825 3.642-8.831 8.584-8.831 2.375 0 4.525.963 6.082 2.52 1.558 1.557 3.019 3.727 3.019 6.102z",
    fill: "#15144F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M42.455 94.603V76.67a7.999 7.999 0 0 0-7.999-8h-.604v25.932h8.603zM14.892 94.605V68.674h-.604a7.999 7.999 0 0 0-7.999 7.998v17.933h8.603z",
    fill: "#F9B29C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.c01c35c4def3a647438114c384abb371.svg";
export { ForwardRef as ReactComponent };